<template>
  <div class="todo-center">
    <x-input-search @search="refreshSearchStr"></x-input-search>
    <cube-tab-bar
      v-model="selectedLabelSlots"
      show-slider
      inline
      class="custom-cube-tab-bar">
      <cube-tab
        v-for="item in tabs"
        :key="item.label"
        :label="item.label">
        <span>{{ item.label }}{{ item.type === 'todo' && todoNumber ? `(${todoNumber})` : '' }}</span>
      </cube-tab>
    </cube-tab-bar>
    <div class="list-wrapper">
      <keep-alive>
        <my-todo
          v-if="selectedLabelSlots === $t('todoCenter.tabTitle.myTodo')"
          :api="myTodoApi"
          :searching="searching"
        />
        <my-submit
          v-else-if="selectedLabelSlots === $t('todoCenter.tabTitle.mySubmit')"
          :api="mySubmitApi"
          :searching="searching"
        />
        <my-participate
          v-else
          :api="myParticipateApi"
          :searching="searching"
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import MyTodo from './my-todolist'
import MySubmit from './my-submit'
import MyParticipate from './my-done'
import apis from '../../api'
import { mapState } from 'vuex'
export default {
  components: {
    MyTodo,
    MySubmit,
    MyParticipate
  },
  data() {
    return {
      selectedLabelSlots: this.$t('todoCenter.tabTitle.myTodo'),
      tabs: [{
        label: this.$t('todoCenter.tabTitle.myTodo'),
        type: 'todo'
      }, {
        label: this.$t('todoCenter.tabTitle.mySubmit')
      }, {
        label: this.$t('todoCenter.tabTitle.myParticipate')
      }],
      myTodoApi: apis.TODO_CENTER.QUERY_MY_TODO_LIST,
      mySubmitApi: apis.TODO_CENTER.QUERY_MY_SUBMIT_LIST,
      myParticipateApi: apis.TODO_CENTER.QUERY_MY_PARTICIPATE_LIST,
      searching: ''
    }
  },
  computed: {
    ...mapState({
      todoNumber: state => state.tenantModule.todoNumber
    })
  },
  created() {
    let map = {
      'my-todo': this.$t('todoCenter.tabTitle.myTodo'),
      'my-submit': this.$t('todoCenter.tabTitle.mySubmit'),
      'my-participate': this.$t('todoCenter.tabTitle.myParticipate')
    }
    if (this.$route.query.type) {
      this.selectedLabelSlots = map[this.$route.query.type]
    }
  },
  methods: {
    refreshSearchStr(searchStr) {
      this.searching = searchStr
    }
  }
}
</script>

<style lang="scss" scoped>
.todo-center {
  height: 100%;
  .seatch-bar {
    margin: 0 1.143rem;
    height: 2.2857rem;
    position: relative;
    .cube-input {
      height: 100%;
      &::after{
        border: 0;
      }
    }
    .search-icon {
      position: absolute;
      width: 1.42857rem;
      height: 1.42857rem;
      left: 1rem;
      top: .42857rem;
      align-items: center;
      display: flex;
    }
  }
  .custom-cube-tab-bar {
    height: 3.2857rem;
    .cube-tab_active {
      color: $--app-primary-color;
    }
    .cube-tab-bar-slider {
      background-color: $--app-primary-color !important;
    }
  }
  .list-wrapper {
    background: $--app-body-bgColor;
    height: calc(100% - 10.4173rem);
  }
}
</style>

<style lang="scss">
.todo-center {
  .seatch-bar {
    .cube-input {
      .cube-input-field {
        background: $--app-body-bgColor;
        padding-left: 3.214rem;
        border-radius: 1rem;
        height: 100%;
      }
    }
  }
  .custom-cube-tab-bar {
    .cube-tab-bar-slider {
      left: 10%;
      width: 13.5% !important;
      background-color: $--app-primary-color !important;
    }
  }
}
</style>
